export default __webpack_public_path__ + "static/media/transaction.774ea3e0.svg";